import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
    getGooglePayEnvironment,
    getLocaleProps,
} from '../../../selectors/app';
import { getGooglePayPaymentRequest } from '../../../selectors/googlePay';
import { CheckoutState } from '../../../state';

const mapStateToProps = (state: CheckoutState) => ({
    environment: getGooglePayEnvironment(state),
    paymentRequest: getGooglePayPaymentRequest(state),
    ...getLocaleProps(state),
});

export const mapDispatchToProps = (_: Dispatch<CheckoutState>) => ({
    handleSubmit: async (paymentData: google.payments.api.PaymentData) => {
        // TODO: EB-186770 - handle submit, redirect to confirmation page
        console.log('handleSubmit');
        console.log(paymentData);
    },
});

export const connectGooglePayButton = connect(
    mapStateToProps,
    mapDispatchToProps,
);
